import { makeObservable, observable, flow, action, computed } from "mobx";
import { toast } from "sonner";

import { api } from "@/lib/services";
import { ApiRoutes } from "@/lib/routes";

import CreateBoardSchema from "@/areas/demand/schemas/CreateBoardSchema";

export default class CreateBoardStore {
  visible = false;
  processing = false;

  constructor(parentStore) {
    makeObservable(this, {
      visible: observable,
      processing: observable,
      show: action,
      hide: action,
      toggle: action,
      save: flow,
      canCreate: computed,
    });

    this.parentStore = parentStore;
  }

  get canCreate() {
    return this.parentStore.parentStore.authenticationStore.isAdmin;
  }

  show() {
    this.visible = true;
  }

  hide() {
    this.visible = false;
  }

  toggle(visible) {
    this.visible = visible === true || visible === false ? visible : !this.visible;
  }

  *save(data) {
    const parseResult = CreateBoardSchema.safeParse(data);
    if (!parseResult.success) {
      return parseResult;
    }

    try {
      this.processing = true;
      const response = yield api.post(ApiRoutes.forBoards(), parseResult.data);
      this.visible = false;
      toast.success("Board created");
      return { success: true, data: response.data };
    } catch (e) {
      toast.error("Error creating board", {
        description:
          e?.response?.data?.message || e?.response?.data || "Unexpected error, please try again later.",
      });
      return { success: false, error: e };
    } finally {
      this.processing = false;
    }
  }
}
